import { FormEvent, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { makeApiCall } from "src/api/apiRequests";
import { useNavigate } from "react-router-dom";
import { PermissionCheck } from "src/helpers/PermissionCheck";
import API_HEADERS from "src/api/apiConfig";
import API_PATHS from "src/api/apiPaths";
import Loading from "src/helpers/Loading";
import FLASH_MESSAGES from "src/helpers/FlashMessages";
import * as ConfirmPopup from "../../../helpers/ConfirmPopup";
import useSearchSubmit from "src/hooks/useSearchSubmit";
import SearchFilter from "src/helpers/SearchFilter";
import PATHS from "src/routes/Paths";
import ListResponse from "src/helpers/ListResponse";
import CustomPagination from "src/helpers/CustomPaginate";

const Roles = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [rolesList, setRolesList] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [name, setName] = useState("");
  const [pagination, setPagination] = useState<any>([]);
  const {
    searchInputs,
    searchBtnLoading,
    searched,
    page,
    setSearchBtnLoading,
    handleSubmit,
    setPage,
  } = useSearchSubmit();

  const getRoleList = async (e?: FormEvent<HTMLFormElement>): Promise<void> => {
    e?.preventDefault();

    let searchParams: any = searchInputs;
    let request: any = API_PATHS.rolesList;
    request = SearchFilter(searchParams, request);
    try {
      const response: any = await makeApiCall<ResponseType>(
        request,
        "GET",
        API_HEADERS.authenticated
      );
    
      setLoading(false);
      setRolesList(response.roles.data);
      setPagination(response.roles);
    } catch (error: any) {
     
      FLASH_MESSAGES.errorMsg(error.response.data.error);
      navigate(-1);
    } finally {
      setSearchBtnLoading(false);
    }
  };
  useEffect(() => {
    getRoleList();
  }, [searched, searchInputs]);

  const deleteRole = (roleId: number, roleTitle: string) => {
    ConfirmPopup.deletePopup(
      t("delete_role_title"),
      t("delete_role_type"),
      roleTitle
    ).then(async (response) => {
      if (response.isConfirmed) {
        try {
          const response: any = await makeApiCall<ResponseType>(
            API_PATHS.deleteRole(roleId),
            "DELETE",
            API_HEADERS.authenticated
          );
          FLASH_MESSAGES.successMsg(response.success);
          if (rolesList.length === 1 && page > 1) {
            setPage(page - 1);
          } else {
            getRoleList();
          }
        } catch (error: any) {
          if (error.response.data.error) {
            FLASH_MESSAGES.errorMsg(error.response.data.error);
          }
        }
      }
    });
  };

  return (
    <>
      <form
        onSubmit={(e) =>
          handleSubmit(e, {
            ...(name && { name: name }),
          })
        }
        className="row"
      >
        <div className="form-block col-12 col-sm-6 col-md-2">
          <label>{t("teachers_term")}</label>
          <input
            placeholder={t("teachers_search_by_term")}
            className="form-input"
            value={name}
            name="name"
            type="text"
            onChange={(e) => setName(e.target.value)}
          />
        </div>
        <div className="col-12 col-sm-6 col-md-3 col-xxl-2 mb-1">
          {searchBtnLoading ? (
            <button type="button" className="mt-4 button-orange has-icon">
              <i className="icon spinner-icon" />
              {t("staff_searching_btn")}
            </button>
          ) : (
            <button type="submit" className="mt-4 button-orange has-icon">
              <i className="icon search-icon" />
              {t("staff_search_btn")}
            </button>
          )}
        </div>
      </form>
      {PermissionCheck("role-store") ? (
        <div className="d-flex justify-content-end mb-5 ">
          <button
            className="button-blue has-icon"
            onClick={() => navigate(PATHS.createRole)}
          >
            <i className="icon plus-icon" />
            {t("add_button_roles")}
          </button>
        </div>
      ) : (
        ""
      )}

      <div className="table-list mb-5">
        <table role="table" className="w-100">
          <thead>
            <tr role="row">
              <th
                style={{ width: "80%" }}
                role="columnheader"
                className="text-left"
              >
                <i className="icon  role-name-icon " />
                {t("role_name")}
              </th>

              <th
                style={{ width: "20%" }}
                role="columnheader"
                className="text-center"
              >
                <i className="icon actions-icon" />
                {t("staff_actions")}
              </th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td className="text-center" colSpan={2}>
                  <Loading />
                </td>
              </tr>
            ) : (
              rolesList.map((role: any) => (
                <tr key={role.id}>
                  <td
                    role="cell"
                    className="text-left bold-text"
                    data-label={t("role_name")}
                  >
                    {role.name}
                  </td>

                  <td
                    role="cell"
                    className="text-center "
                    data-label={t("staff_actions")}
                  >
                    <div className="actions">
                      {PermissionCheck("role-update") ? (
                        <button
                          className="button-unstyled"
                          onClick={() => navigate(PATHS.updateRole(role.id))}
                        >
                          <i className="icon edit-icon " />
                        </button>
                      ) : (
                        ""
                      )}
                      {PermissionCheck("role-delete") ? (
                        <button
                          type="button"
                          key={role.id}
                          className="button-unstyled"
                          onClick={() => deleteRole(role.id, role.name)}
                        >
                          <i className="icon delete-icon" />
                        </button>
                      ) : (
                        ""
                      )}
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
        <ListResponse totalItems={rolesList?.length} loading={loading} />
      </div>
      <CustomPagination data={pagination} setActivePage={(e) => setPage(e)} />
    </>
  );
};
export default Roles;
